import React from "react";
import classes from "./BookNowBtn.module.css";
import { images } from "../../assets/img";
import { useNavigate } from "react-router-dom";
import { INFORMATIONS } from "../../utils/Const";

const BookNowBtn = (props) => {
  const navigate = useNavigate();
  const { isShowArrow = true } = props;

  const onClickBookNow = () => {
    if (props?.onClick) {
      props?.onClick?.();
      return;
    }
    // navigate('/booking')
    // window.open(`tel:${INFORMATIONS.tel}`);
       window.open(`https://www.order.store/store/xin-chao-vietnamese-street-food/ICZeG7byTk24FJLhf4JtrA?fbclid=IwY2xjawOst7JleHRuA2FlbQIxMABicmlkETFzY25od3pwR0tSS3AyaERZc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHrsNeLM7MV5qLIULAw0oO2jxHZH5Hqv3j9uWnh5EEMoQn_bt7tgywWbvSZxB_aem_v5T5fmg9g3C5R-vGNJLvBA`, '_blank');
  };

  return (
    <button type={props?.type} className={classes.button}>
      <div
        onClick={onClickBookNow}
        className={`${classes.bookNowBtn} ${props?.style}`}
      >
        <h3 className={classes["change-color-on-hover"]}>ORDER NOW</h3>
        {isShowArrow ? (
          <img alt={"right-arrow"} src={images.leftArrow} />
        ) : null}
      </div>
    </button>
  );
};

export default BookNowBtn;
